import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

// Ortak cihaz kaydı (Device) — sistem geneli, `/Cihazlar` sayfası Admin/AdminStaff
// rotası olduğu için uçlar `/api/admin/*` altındadır. Cihaz kimliği MAC'tir,
// mutasyonlar `deviceId` ile çalışır (eski medicine-device uçları seri no
// kullanıyordu — seri no artık sunucu tarafında üretilen bir ETİKET).
//
// Cihaz OLUŞTURMA ucu bilinçli olarak YOKTUR: cihazlar mobil uygulamadan admin
// girişiyle BLE ile bağlanılarak tanıtılır (`/api/mobile/devices/provision`).
const deviceApi = createApi({
  reducerPath: "devices",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ["Devices"],
  endpoints: (builder) => ({
    // Tüm cihazları listele (+ durum sayımları)
    getAllDevices: builder.query({
      query: (data) => apiFunction(data, "/api/admin/devices/list", "POST"),
      providesTags: ["Devices"],
    }),

    // Tek bir cihazı getir
    getDevice: builder.query({
      query: (data) => apiFunction(data, "/api/admin/devices/detail", "POST"),
      providesTags: ["Devices"],
    }),

    // Cihazı hastaya ata
    assignToPatient: builder.mutation({
      query: (data) => apiFunction(data, "/api/admin/devices/assign-patient", "POST"),
      invalidatesTags: ["Devices"],
    }),

    // Cihazı servise ata
    assignToService: builder.mutation({
      query: (data) => apiFunction(data, "/api/admin/devices/assign-service", "POST"),
      invalidatesTags: ["Devices"],
    }),

    // Cihazı depoya ata
    assignToDepot: builder.mutation({
      query: (data) => apiFunction(data, "/api/admin/devices/assign-depot", "POST"),
      invalidatesTags: ["Devices"],
    }),

    // Cihaz sil
    deleteDevice: builder.mutation({
      query: (data) => apiFunction(data, "/api/admin/devices/delete", "POST"),
      invalidatesTags: ["Devices"],
    }),
  }),
});

export const {
  useLazyGetAllDevicesQuery,
  useLazyGetDeviceQuery,
  useAssignToPatientMutation,
  useAssignToServiceMutation,
  useAssignToDepotMutation,
  useDeleteDeviceMutation,
} = deviceApi;

export { deviceApi };
